import { ROLE_TYPE } from './types';
import useRequireRoles from './useRequireRoles';
import useRoles from './useRoles';

export const useIsPublisher = () => useRoles(ROLE_TYPE.PUBLISHER);
export const useRequirePublisher = () => useRequireRoles(ROLE_TYPE.PUBLISHER);
